<template>
  <transition name="fade">
    <div v-if="!!content" class="login-confirm-notice">
      <div class="content" v-html="content" />
      <slot>
        <div class="operation">
          <button class="confirm" @click="ok">
            {{ okText || $t('confirm') }}
          </button>
          <button v-if="hasCancel" class="cancel" @click="cancel">
            {{ cancelText || $t('cancel') }}
          </button>
        </div>
      </slot>
    </div>
  </transition>
</template>
<script>
let okHandler = null
let cancelHandler = null
export default {
  name: 'ConfirmBox',
  data() {
    return {
      content: '',
      okText: '',
      cancelText: '',
      hasCancel: true
    }
  },
  methods: {
    show(props) {
      const { ok, cancel, ...rest } = props
      for (const p in rest) {
        this[p] = props[p]
      }
      if (ok) okHandler = ok
      if (cancel) cancelHandler = cancel
    },
    ok() {
      this.content = ''
      okHandler && okHandler()
    },
    cancel() {
      this.content = ''
      cancelHandler && cancelHandler()
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.login-confirm-notice {
  position: absolute;
  width: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 15px;
  background: white;
  border-radius: 4px;
  box-shadow: @box-shadow-1 fade(#000000, 10);
  z-index: 10;
  .content {
    margin-bottom: 20px;
  }
  .operation {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    button {
      width: 100px;
      height: 30px;
      line-height: 30px;
      padding: 0;
      margin-right: 20px;
      color: white;

      &:last-child {
        margin-right: 0;
      }
    }
    .confirm {
      background: var(--login-active-color);
    }
    .cancel {
      background: #a0aaaf;
    }
  }
}
</style>
